<script>
import { mapState, mapGetters } from 'vuex';

import Col from './col.vue';
import StateIcon from '../components/StateIcon/index.vue';
import MultiLineText from '../components/MultiLineText/index.vue';

import { deviceContextMenu } from '../utils/contextMenu';

import MultiAlarm from '@/components/dispositionAlarm/multi.vue';
import SingleAlarm from '@/components/dispositionAlarm/single.vue';
import MCard from '@/components/mCard/index.vue';

import { List } from '@/utils/List';
import { isEmpty } from '@/utils/is';
import { getDeviceTypeImg } from '@/utils/deviceUtils/index';

import mixins from './mixins';
import { getOptions, getStateHighLevelOptionBy, isNormal } from '@/utils/deviceUtils/state';

export default {
  mixins: [mixins],
  components: { StateIcon, MultiAlarm, SingleAlarm, Col, MultiLineText, MCard },
  inject: ['openParamsDialog'],
  data() {
    return {
      prev: '',
      list: [],
      monitorConfig: {
        multiColumn: false,
        fontSize: 24,
        groupBy: 'place'
        // groupBy: 'deviceType'
      }
    };
  },
  computed: {
    ...mapState('socket', {
      deviceSNMap: 'deviceSNMap',
      deviceIdMap: 'deviceIdMap',
      allDeviceList: 'devicesSourseMap'
    }),
    ...mapGetters('mqtt', ['alarmSnMap']),
    isInline() {
      return !this.monitorConfig.multiColumn;
    },
    title() {
      const id = this.$route.params.id;

      return `${this.$t('监测设备')}(${this.deviceIdMap[id]?.name})`;
    },
    deviceList() {
      const id = this.$route.params.id;

      if (isEmpty(id)) return this.allDeviceList;

      const list = this.deviceIdMap[id]?.children;

      const res = isEmpty(list) ? [] : list;

      return res.sort((a, b) => {
        return (
          (getOptions(b.runstate, b.state2).l2 || 0) - (getOptions(a.runstate, a.state2).l2 || 0)
        );
      });
    },
    deviceMinWidth() {
      if (this.isGroupByPlace) {
        return this.isInline ? 230 : this.monitorConfig.fontSize * 7 * 1.35;
      } else {
        return this.isInline ? 430 : this.monitorConfig.fontSize * 7 * 1.35;
      }
    },
    stateMinWidth() {
      const min = this.monitorConfig.fontSize * 1.35 * 2.2;
      return this.isInline ? Math.max(min * 1.5, 160) : Math.max(min * 2, 120);
    },
    positionMinWidth() {
      return this.monitorConfig.fontSize * 5 * 1.35;
    },
    multiColumn() {
      // return true;
      return this.monitorConfig.multiColumn;
    },
    isGroupByPlace() {
      return this.monitorConfig.groupBy === 'place';
    },
    group() {
      const list = new List(this.deviceList);

      const res = list.groupBy('deviceType').list;

      return res;
    },
    posGroup() {
      const list = new List(this.deviceList);

      const res = list.groupBy('dynamicInfoMap.location_desc').list.map(e => {
        if (isEmpty(e.key)) e.key = '其他';
        return e;
      });

      return res;
    },
    tableConfig() {
      const spanConfig = {};
      const data = [];
      const group = this.isGroupByPlace ? this.posGroup : this.group;

      group.sort((a, b) => {
        const al = getStateHighLevelOptionBy(a.items, { useLevel2: true }).l2;
        const bl = getStateHighLevelOptionBy(b.items, { useLevel2: true }).l2;

        a.sort = al;
        b.sort = bl;

        return bl - al;
      });

      group.forEach(e => {
        const len = data.length;
        if (this.multiColumn) {
          let items = [];
          e.items.forEach((item, index) => {
            item.col2 = null;
            if ((index + 1) % 2 === 0) {
              items.slice(-1)[0].col2 = item;
            } else {
              items.push(item);
            }
          });
          data.push(...items);
          spanConfig[len] = Math.ceil(e.items.length / 2);
        } else {
          data.push(...e.items);
          spanConfig[len] = e.items.length;
        }
      });
      return { spanConfig, data };
    }
  },
  methods: {
    getDeviceTypeImg,
    openContextmenu: deviceContextMenu,
    spanHandler({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowspan = this.tableConfig.spanConfig[rowIndex];
        if (rowspan) {
          return {
            rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    handleRightClick(row, column, event) {
      const key = this.isGroupByPlace ? '设备' : '位置';

      const text = this.$t(key);

      if ([text, `${text}2`].includes(column.label)) {
        event.preventDefault();

        const _row = text === column.label ? row : row.col2;

        const sn = _row.sn;
        const deviceType = _row.deviceType;

        if (isEmpty(_row) || isEmpty(sn) || isEmpty(deviceType)) return;

        this.openContextmenu(event, _row);
      }
    },
    handleAlarmIconClick({ sn }) {
      const singleAlarm = this.$refs.singleAlarm;
      const multiAlarm = this.$refs.multiAlarm;
      const alarmList = this.alarmSnMap[sn];

      if (isEmpty(alarmList)) {
        // TODO 无报警数据处理
        return;
      }

      if (alarmList.length === 1) {
        singleAlarm.show();
        singleAlarm.setData(alarmList[0]);
      } else {
        multiAlarm.show();
        multiAlarm.setTableData(alarmList);
      }
    }
  },
  watch: {
    'monitorConfig.fontSize'() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    'monitorConfig.multiColumn'() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    'monitorConfig.groupBy'() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    deviceList: {
      handler(n) {
        this.$nextTick(() => {
          if (isEmpty(n)) return;

          if (isNormal(n[0]?.state, n[0]?.runstate)) return;

          if (this.prev === n[0].sn) return;

          this.prev = n[0].sn;

          const el = document.querySelector(`#sn-${n[0].sn}`);

          // console.log(n, el);

          if (!isEmpty(el)) el.scrollIntoView(true);
        });
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.cotton-monitor_list {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;

  width: 100%;
  height: 100%;

  box-sizing: border-box;

  .title {
    text-align: center;
    font-size: var(--font-size);
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: var(--cotton-list-title-color);

    padding: 24px 0;
  }

  .cotton-monitor-table {
    user-select: none;
    font-size: var(--font-size);
    font-family: Source Han Sans CN;
    font-weight: 400;

    .el-table__header thead {
      color: var(--cotton-list-header-color);
    }
    .el-table__body {
      height: 100%;
      color: var(--cotton-list-body-color);

      .state-col {
        padding: unset;
        .cell {
          padding: unset;
          height: 100%;

          display: flex;
          align-items: center;
          justify-content: center;

          padding: 15px 0;
        }
      }
    }
    .cell {
      line-height: 1.6;
    }
    tbody tr:hover > td {
      background-color: transparent !important;
    }

    .col-flex {
      line-height: 1.2;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: calc(var(--font-size) * 0.9);
        height: calc(var(--font-size) * 0.9);
        margin-right: 15px;
      }
    }

    &.el-table--border {
      .el-table__body-wrapper {
        overflow-y: auto;
        position: unset;

        @include scrollar-style-thin;
      }

      td,
      th,
      .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
        border-bottom: 1px solid var(--cotton-list-border-color) !important;
        border-right: 1px solid var(--cotton-list-border-color) !important;
      }
    }
  }

  .device-content {
    display: flex;
    align-items: center;
  }
}
</style>
